// Reveals are intentionally NON-fading so content is always fully readable.
// (Opacity-based scroll reveals previously left content looking dark/hidden.)
export const Reveal = ({ children, className = "" }) => (
  <div className={className}>{children}</div>
);

// Kept for API compatibility with section grids — no opacity change.
export const stagger = { hidden: {}, show: {} };
export const item = { hidden: { opacity: 1, y: 0 }, show: { opacity: 1, y: 0 } };
